import { State } from 'model/State';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { postToHamsClient } from '../../../../util/mac/api/noteAccount/post';

export const postNoteAccountAPI = (
  accountId: number,
  payload: { author: string; body: string },
  state: State,
) =>
  fetchWithParamValidation(({ id }) => postToHamsClient(`/${id}`, state, {}, payload), {
    id: accountId,
  });
